export default "__VITE_PUBLIC_ASSET__1dbf2e8c__"